<template>
    <div class="flex-row justify-content-end">
        <a href="https://k-98.ru" class="k98-link" target="_blank" rel="noopener" @mouseenter="pickColor">
            сделано <span class="brand" :style="brandStyle">k-98</span>
        </a>
    </div>
</template>

<script>
export default {
	name: "K98LinkComponent",
	data() {
		return {
			palette: [
				'#E8430A', '#D62828', '#E63946', '#F77F00', '#FCBF49',
				'#06A77D', '#1982C4', '#6A4C93', '#C9184A', '#FF6B35',
				'#2EC4B6', '#E71D36',
			],
			lastIndex: -1,
			currentColor: '#E8430A',
		}
	},
	computed: {
		brandStyle() {
			return {
				'--k98-color': this.currentColor,
			}
		},
	},
	methods: {
		pickColor() {
			let index
			do {
				index = Math.floor(Math.random() * this.palette.length)
			} while (index === this.lastIndex)
			this.lastIndex = index
			this.currentColor = this.palette[index]
		},
	},
}
</script>

<style scoped>
.k98-link {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	text-decoration: none;
	font-size: 10px;
	font-weight: 500;
	color: #b0b0b0;
	font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
}

.k98-link .brand {
	font-weight: 800;
	color: #1A1A1A;
	background-image: linear-gradient(
		45deg,
		var(--k98-color, #E8430A) 0%,
		var(--k98-color, #E8430A) 50%,
		#1A1A1A 50%,
		#1A1A1A 100%
	);
	background-size: 350% 350%;
	background-repeat: no-repeat;
	background-position: 100% 100%;
	-webkit-background-clip: text;
	background-clip: text;
	-webkit-text-fill-color: transparent;
	transition: background-position 0.6s cubic-bezier(0.65, 0, 0.35, 1);
}

.k98-link:hover .brand {
	background-position: 0% 0%;
}
</style>